import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en.json';
import fr from '@/locales/fr.json';

export const supportedLanguages = ['en', 'fr'];
const resources = {
    en: { translation: en },
    fr: { translation: fr },
};

i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'fr',
    fallbackLng: 'fr',
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});

export default i18n;
